import cookieConfig from '@/config/cookie'

/**
 * Generates a cookie type
 *
 * @param name
 * @returns {string}
 */
export const generateCookieType = name => cookieConfig.prefix + name

/**
 * Generates cookie domain
 *
 * @returns {string|undefined}
 */
export const getCookieDomain = () => {
  const baseURL = process.env.BASE_URL

  if (baseURL.includes('ota.local') || baseURL.includes('localhost') || !baseURL.includes('//')) {
    return undefined
  }

  let cookieDomain = baseURL.split('//')[1]

  if (cookieDomain.startsWith('acc.')) {
    cookieDomain = cookieDomain.substring(4)
  } else if (cookieDomain.startsWith('test.')) {
    cookieDomain = cookieDomain.substring(5)
  }

  return cookieDomain
}
